module.exports = __webpack_public_path__ + "static/media/Employee1.f4e4c634.svg";